import vue from 'vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { MessageBox } from 'element-ui';
import i18n from '@/lang';
import axios, { ResponseData, checkCookieValidity, loginTimeoutMessageBox } from './request_config';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { Message, Loading } from 'element-ui';

// 白名单
const whiteList = [
  '/sale/commission/previewSettlement',
  '/sale/commission/submitSettlement',
  '/issue/student/exportEasyExcel',
  '/issue/student/exportStudentExcel',
  '/appFile/issueDownloadList',
  '/appFile/uploadStudent',
  '/appFile/download',
  '/appFile/downloadIssue',
  '/en_cv_parse/',
  '/issue/student/deleteFile',
  '/sale-center/sale/agent/verifyIdCard',
  '/issue/student/exportGearStuApplyListByStuExcel',
  '/issue/student/exportGearStuApplyListByOfferItemExcel',
  '/mps/institutionProviderMpsCommission/exportMpsExcel',
  '/mps/institutionProviderMpsCommission/exportMpsLevelExcel',
];

const noLoadingList = [
  '/issue/permission/addGearUserShortcutMenu',
  '/appInstitution/news/getNewsByTypeName',
  '/appInstitution/popupNotice/current'
]
// 不需要报错的接口
const notErrorMsg:any=[
  '/appInstitution/news/getNewsByTypeName',
  '/appInstitution/popupNotice/current'
]
// 全局loading
let globalLoading: any = null;
// 接口数量
let requestCount: number = 0;

// 开启loading
const startLoading = () => {
  globalLoading = Loading.service({
    text: i18n.t('common.loading') as string,
    background: 'rgba(0, 0, 0, 0)',
    target: document.body,
    lock: true,
    customClass: 'loadingClass'
  })
}
// 当前接口数为0时关闭loading
const endLoading = () => {
  if (globalLoading && requestCount <= 0) {
    vue.nextTick(() => {
      globalLoading.close();
    })
    // setTimeout(() => {
    // }, 500);
  }
}
// 添加1个接口数
const addRequestCount = (() => {
  requestCount++;
})
// 减少1个接口数
const delRequestCount = (() => {
  requestCount--;
})

const service: AxiosInstance = axios.create();

service.interceptors.request.use((config: AxiosRequestConfig) => {
  if (UserModule.token) {
    config.headers.at = UserModule.token;
  }
  config.headers.langCode = AppModule.language;
  config.headers.Languagecode = AppModule.language;
  if (noLoadingList.indexOf(config.url as string) === -1) {
    addRequestCount();
    startLoading();
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

service.interceptors.response.use((response: AxiosResponse<ResponseData>) => {
  const res: ResponseData = response.data;
  const code = res.code;
  if (noLoadingList.indexOf(response.config.url as string) === -1) {
    delRequestCount();
    endLoading();
  } else {
    return response;
  }
  if (code === '1003') {
    return response;
  } else {
    if (code === '0006') {
      loginTimeoutMessageBox(i18n.t('common.loginTimeout') as string);
    } else {
      const url: string = response.config.url as string;
      if (whiteList.indexOf(url) !== -1) {
        return response;
      } else {
        const message = res.message ? res.message : i18n.t('message.unknownError') as string;
        Message.error({
          message: `${i18n.t('common.errorCode')}：${code}，${message}`,
          dangerouslyUseHTMLString: true,
        });
      }
    }
    return Promise.reject(res);
  }
}, (error: AxiosError) => {
  if (noLoadingList.indexOf(error.config.url as string) === -1) {
    delRequestCount();
    endLoading();
  } else {
    return Promise.reject(error);
  }
  const status = error.response?.status;
  if (status === 401) {
    loginTimeoutMessageBox(i18n.t('message.expired') as string)
  } else if (notErrorMsg.indexOf(error.config.url)!==-1){
    return Promise.reject(error);
  } else {
    MessageBox.confirm(
      status + ': ' + i18n.t('message.unknownError') as string,
      i18n.t('common.errorMsg') as string,
      {
        confirmButtonText: i18n.t('common.confirm') as string,
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: false,
    })
  }
  return Promise.reject(error);
});

export default service;
